<template>
    <v-menu ref="menu" v-model="open" :close-on-content-click="false" offset-y offset-overflow
        :max-width="Math.min(600, $vuetify.breakpoint.width - 24)" content-class="skill-chip-menu">
        <template v-slot:activator="{ attrs }">
            <chip-select-field v-bind="attrs" :items="value" label="Навыки" placeholder="Найти навык"
                :search="search" searchable :expanded="open" :loading="loading" :errors="errors"
                @open="open = true" @close="open = false" @update:search="search = $event" @remove="remove" />
        </template>
        <v-card>
            <v-card-text class="skill-chip-options" role="listbox" aria-label="Навыки">
                <div v-if="error" class="error--text">{{ error }} <v-btn text small @click="$emit('search', search)">Повторить</v-btn></div>
                <v-chip v-for="item in filteredItems" :key="item.id" @click="select(item)" @keydown.enter.prevent="select(item)"
                    role="option" tabindex="0" class="ma-1">{{ item.text }}</v-chip>
                <div v-if="!loading && !error && !filteredItems.length" class="grey--text">Навыки не найдены</div>
                <v-progress-linear v-if="loading" indeterminate />
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
import ChipSelectField from './ChipSelectField.vue'
export default {
    name: 'SkillChipSelect',
    components: { ChipSelectField },
    props: {
        value: { type: Array, default: () => [] }, items: { type: Array, default: () => [] },
        errors: { type: Array, default: () => [] }, loading: Boolean, error: { type: String, default: '' },
    },
    data () { return { open: false, search: '', timer: null } },
    computed: {
        filteredItems () {
            const query = this.search.toLocaleLowerCase('ru').replace(/ё/g, 'е').trim()
            return this.items.filter(item => !this.value.some(selected => String(selected.id) === String(item.id))
                && item.text.toLocaleLowerCase('ru').replace(/ё/g, 'е').includes(query))
        },
    },
    watch: {
        open (open) { if (open) this.$emit('search', this.search) },
        filteredItems () {
            // Async suggestions can change the menu height after it was positioned.
            this.$nextTick(() => { if (this.open && this.$refs.menu) this.$refs.menu.updateDimensions() })
        },
        search (query) {
            clearTimeout(this.timer)
            this.open = true
            this.timer = setTimeout(() => this.$emit('search', query), 250)
        },
    },
    beforeDestroy () { clearTimeout(this.timer) },
    methods: {
        select (item) {
            if (!this.value.some(selected => String(selected.id) === String(item.id))) this.$emit('input', [...this.value, item])
            clearTimeout(this.timer)
            this.search = ''
            this.$nextTick(() => { this.open = false })
        },
        remove (id) { this.$emit('input', this.value.filter(item => String(item.id) !== String(id))) },
    },
}
</script>

<style scoped>
.skill-chip-options { max-height: 320px; overflow-y: auto; padding: 12px; }
.skill-chip-options .v-chip { height: auto; min-height: 32px; max-width: 100%; }
.skill-chip-options ::v-deep .v-chip__content { white-space: normal; height: auto; padding: 6px 0; }
</style>
